import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface RsaSearchDisplayPathModel extends BaseModel {
  variables?: { [key: string]: string } | RsaSearchDisplayPathVariables;
}

export interface RsaSearchDisplayPathVariables {
  FirstPart: string;
  SecondPart: string;
}

export class RsaSearchDisplayPathInitVariables implements RsaSearchDisplayPathVariables {
  FirstPart = '';
  SecondPart = '';
}

export class RsaSearchDisplayPathInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new RsaSearchDisplayPathInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
